import {
  FNI_PRESENT_FLOW_QUERY_PARAM,
  InstoreUrlPaths,
} from '../containers/PencilEditor/types';

export default class InstoreService {
  static async setToken(token: string) {
    const inStoreUrl = process.env.REACT_APP_INSTORE_URL;
    return fetch(`${inStoreUrl}/api/auth`, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ token }),
    });
  }

  static getInstoreFinanceOffersUrl(dealId: string) {
    return `${process.env.REACT_APP_INSTORE_URL}/${InstoreUrlPaths.OFFERS}?dealId=${dealId}&${FNI_PRESENT_FLOW_QUERY_PARAM}=true`;
  }

  static getLoanConfirmationUrl(dealId: string, selectedResponseId: string) {
    return `${process.env.REACT_APP_INSTORE_URL}/${InstoreUrlPaths.LOAN_CONFIRMATION}?dealId=${dealId}&selectedResponseId=${selectedResponseId}&showOfferReview=true`;
  }

  static getInstoreDocumentSigningUrl(dealId: string) {
    return `${process.env.REACT_APP_INSTORE_URL}/${InstoreUrlPaths.DOCUMENT_SIGNING}?dealId=${dealId}`;
  }
}
